import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Outlet } from "react-router-dom";

const CoalerApp = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default CoalerApp;
